module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.email) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(adres e-mail)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('emails-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0076bb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Edit.vue
// module id = 222
// module chunks = 0